import { keyBy } from 'lodash-es';
import { CommentThreadBase, LastCommentMessage, CommentParticipant, CommentThreadOverview } from '@/types';

export interface ProjectOverview {
    projectId: number;
    tasks: ProjectTaskOverview | null;
    changeRequests: ProjectChangeRequestOverview;
    comments: CommentThreadOverview[] | null;
    total: number | null;
}
export interface ProjectChangeRequestOverview {
    total: number | null;
}

export interface ProjectTaskOverview {
    documents: number;
    optionGroups: number;
    orders: number;
    projectDocuments: number;
    externalAgreements: number;
    total: number;
}

const initialState: ProjectOverview = {
    projectId: 0,
    tasks: null,
    changeRequests: {
        total: null,
    },
    comments: null,
    total: null,
};
function mergeComments(prevState: ProjectOverview, data: CommentThreadOverview[]) {
    const oldData = prevState?.comments ?? [];
    const newData = keyBy(data, 'threadId');
    const result = oldData.map((x) => {
        const newItem = newData[x.threadId];
        if (newItem) {
            delete newData[x.threadId];
            return newItem;
        }

        return x;
    });

    result.push(...Object.values(newData));
    return result;
}

const projectOverview = (state = initialState, action): ProjectOverview => {
    switch (action.type) {
        case 'SELLER_PROJECT_OVERVIEW_CLEAR':
            return initialState;
        case 'SELLER_PROJECT_OVERVIEW_SET':
            return action.data;
        case 'SELLER_PROJECT_TASK_OVERVIEW_SET':
            return { ...state, tasks: action.data };
        case 'SELLER_PROJECT_CR_OVERVIEW_SET':
            return { ...state, changeRequests: action.data };
        case 'SELLER_PROJECT_COMMENTS_OVERVIEW_SET':
            return { ...state, comments: mergeComments(state, action.data) };
        default:
            return state;
    }
};

export default projectOverview;
